import { Navigate } from 'react-router-dom'

import AuthService from '../../utilities/services/auth.service'
import { ClientReportWrapper } from '../../components'

export default function ClientReportPage() {
  const organizations = AuthService.getOrg() || []
  const currentUser = AuthService.getUser()?.user
  const isSuperUser = Boolean(
    organizations.some((organization) =>
      organization?.members?.some(
        (member) => member?.uuid === currentUser?.uuid && member?.superAdmin
      )
    )
  )

  if (!isSuperUser) {
    return <Navigate to="/" replace />
  }

  return <ClientReportWrapper />
}
